import type SeatIconBuilder from '../seatIcons/SeatIconBuilder';
import getGraphicType from './getGraphicType';
import {
  SeatApiData, Section, SyosSeatData, Zone,
} from './types';

class SeatDataBuilder {
  constructor(private readonly seatIconBuilder: typeof SeatIconBuilder) {
  }

  build(seatApiData: SeatApiData, sections: Section[], zones: Map<number, Zone>): SyosSeatData {
    const sectionId = seatApiData.section;
    const zoneId = seatApiData.zone_no;
    const status = seatApiData.seat_status;

    const section = sections
      .find((el) => el.section === sectionId)!;

    const zone = zones.get(zoneId)!;

    const isAvailable = status === 0;

    const graphicType = getGraphicType(seatApiData.GraphicType, isAvailable);

    const icon = this.seatIconBuilder.build(seatApiData.IconCharacter, graphicType);

    return {
      sectionId,
      zone,
      status,
      graphicType,
      icon,
      isAvailable,
      id: seatApiData.seat_no,
      seatNumber: seatApiData.seat_num?.trim(),
      row: seatApiData.seat_row?.trim(),
      statusDescription: seatApiData.seat_status_desc,
      description: seatApiData.seat_desc,
      zoneLabel: seatApiData.ZoneLabel,
      type: seatApiData.seat_type,
      sectionDescription: section.section_desc,
      x: seatApiData.xpos,
      y: seatApiData.ypos,
      fillColor: seatApiData.CustomFill,
      displayLetter: seatApiData.display_letter,
      iconCharacter: seatApiData.IconCharacter,
    };
  }
}

export default SeatDataBuilder;
